/* global axios */
import ApiClient from './ApiClient';

class ViewCountsAPI extends ApiClient {
  constructor() {
    super('view_counts', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default new ViewCountsAPI();
